import { FormProvider } from '@neo/blocks/forms/form-provider'
import { useMemo } from 'react'
import { Navigate, Route, Routes } from 'router-v6'
import { getDefaultRoute, openRoutes } from 'v2/configs/routes'
import { reportEmbedRenderError } from './pages/embed/embed-messaging'
import { NotFoundPage } from './pages/misc/404'
import { ErrorBoundary } from './shared/components/error-boundary'
import { ProtectedRoute } from './shared/components/protected-route'
import { useRoutes } from './shared/hooks/use-routes'
import { MainLayout } from './shared/layouts/main'
import { generateRoutes } from './utils'

/**
 * The main application component.
 * @returns The rendered application component.
 */
export const App = () => {
  const routes = useRoutes()
  const memoizedRoutes = useMemo(() => generateRoutes(routes), [routes])

  return (
    <div className="bg-hv3">
      <div className="h-full w-full mx-auto bg-background">
        <FormProvider>
          <ErrorBoundary className="h-screen" onError={reportEmbedRenderError}>
            <Routes>
              <Route element={<ProtectedRoute children={<MainLayout />} />}>
                {memoizedRoutes}
                {/* This is a catch-all route that will redirect to the settings page if the user tries to access the root path. */}
                {/* TODO_V2: We will update it later to redirect to the conversations page. */}
                <Route index element={<Navigate to={getDefaultRoute()} replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
              {generateRoutes(openRoutes)}
              <Route index element={<Navigate to="/login" />} />
            </Routes>
          </ErrorBoundary>
        </FormProvider>
      </div>
    </div>
  )
}
